import { IIdentity } from '@grid/models';
import { ImportExcelWarningType, ImportWarningStatus } from '@shared/enums';
import { DataType } from '@shared/models';

export interface ImportWarningGridData extends IIdentity {
  name: string;
  dataType: ImportExcelWarningType;
  dataTypeId?: DataType;
  dataTypeName: string;
  status: ImportWarningStatus;
  createdDataId?: number;
}
